import { SvgIcon, SxProps } from "@mui/material";
import SvgUsersIcon from "jsx:../../../Images/Icons/Custom/fallbackAvatarGroup.svg";

export function UsersIcon(props: SxProps) {
    return (
        <SvgIcon
            component={SvgUsersIcon}
            inheritViewBox
            sx={{
                ...props,
                width: "100%",
                height: "100%",
            }}
        />
    );
}
